import { SectionNames } from 'builder/modules/resumeEditor'
export const LOCALIZATION_PREFIX = 'builder.resume_editor.step_by_step_editor'
export const WORK_EXPERIENCE_ANALYTICS_SECTION_NAME = 'work_experience'

export const BACK_BUTTON_CONDITION_WITH_SCORE_THRESHOLD = 15

export const STEP_BY_STEP_FLOW_VISITED_SECTIONS_LOCAL_STORAGE_KEY =
  'STEP_BY_STEP_FLOW_VISITED_SECTIONS_LOCAL_STORAGE_KEY'

export const defaultSectionOrder = [
  SectionNames.details,
  SectionNames.workExperiences,
  SectionNames.educations,
  SectionNames.skills,
  SectionNames.profile,
  SectionNames.internships,
  SectionNames.courses,
  SectionNames.activities,
  SectionNames.languages,
  SectionNames.references,
  SectionNames.hobbies,
  SectionNames.accomplishments,
  SectionNames.socialProfiles,
]

export const athensSectionOrder = [
  SectionNames.details,
  SectionNames.workExperiences,
  SectionNames.educations,
  SectionNames.skills,
  SectionNames.profile,
  SectionNames.internships,
  SectionNames.courses,
  SectionNames.activities,
  SectionNames.accomplishments,
]

export const shanghaiSectionOrder = [
  SectionNames.details,
  SectionNames.workExperiences,
  SectionNames.educations,
  SectionNames.skills,
  SectionNames.powerStatement,
  SectionNames.profile,
  SectionNames.accomplishments,
  SectionNames.internships,
  SectionNames.activities,
  SectionNames.courses,
]

export const pragueSectionOrder = [
  SectionNames.details,
  SectionNames.workExperiences,
  SectionNames.educations,
  SectionNames.skills,
  SectionNames.profile,
  SectionNames.courses,
  SectionNames.activities,
  SectionNames.internships,
]
